import type { ReactNode } from 'react';
import { MGTile } from '@/components/MGTile';
import type { MotionGraphics, SearchResponseHit } from '@music-vine/setlist';
interface MgHitToTileOptions {
  // LUTs reuse the MG tile but hide the compatibility badge and use LUT download behaviour.
  isLut?: boolean;
}

// Map a motion-graphics (or LUT) hit to its `MGTile`; callers own the `.map` and `'document' in hit` guard.
export const mgHitToTile = (hit: SearchResponseHit<MotionGraphics>, {
  isLut = false
}: MgHitToTileOptions = {}): ReactNode => <MGTile compatibility={hit.document.compatibility} fileSize={hit.document.file_size} hideCompatibility={isLut} id={hit.document.id} image={hit.document.image} isLut={isLut} key={`mg-tile-${hit.document.id}`} meta={{
  contributor: hit.document.contributor.name,
  setLiveUnixTimestamp: hit.document.set_live ?? 0,
  resolution: hit.document.resolution,
  isPremium: hit.document.is_premium,
  compatibility: hit.document.compatibility,
  onAlpha: hit.document.on_alpha,
  relevanceFree: hit.document.relevance_free,
  relevancePremium: hit.document.relevance_premium,
  isFeatured: hit.document.is_featured,
  downloadCountFree: hit.document.free_download_count,
  playCountFree: hit.document.free_play_count,
  downloadCountPremium: hit.document.premium_download_count,
  playCountPremium: hit.document.premium_play_count
}} mgSlug={hit.document.slug} title={hit.document.name} video={hit.document.preview_video_url} data-sentry-element="MGTile" data-sentry-component="mgHitToTile" data-sentry-source-file="mg-hit-to-tile.tsx" />;